import { render, staticRenderFns } from "./wb-footer.vue?vue&type=template&id=0ee2540c&scoped=true"
import script from "./wb-footer.vue?vue&type=script&lang=js"
export * from "./wb-footer.vue?vue&type=script&lang=js"
import style0 from "./wb-footer.vue?vue&type=style&index=0&id=0ee2540c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee2540c",
  null
  
)

export default component.exports